"use client";

import { PropertyActionCard } from "./property-action-card";

interface ClientSavingsCardProps {
  masterkeySavings: number;
  property: { url?: string; address?: string; id?: string } | null;
  propertyId: string | null;
  slug: string;
  isLimited?: boolean;
}

export function ClientSavingsCard({
  property,
  propertyId,
  slug,
  isLimited,
  masterkeySavings,
}: ClientSavingsCardProps) {
  return (
    <PropertyActionCard
      property={property}
      propertyId={propertyId}
      slug={slug}
      isLimited={isLimited}
      masterkeySavings={masterkeySavings}
    />
  );
}
